import React, { useEffect, useState } from "react";
import { Chart as ChartJS, defaults } from "chart.js/auto";
import { Line } from "react-chartjs-2";
import revenueData from "../../../data/revenueData.json";

defaults.maintainAspectRatio = false;
defaults.responsive = true;

defaults.plugins.title.display = true;
defaults.plugins.title.align = "start";
defaults.plugins.title.font.size = 20;
defaults.plugins.title.color = "black";

const LineStatistique = ({don}) => {

  return (
    <Line
      data={{
        labels: revenueData.map((data) => data.label),
        datasets: [
          // {
          //   label: "Revenue",
          //   data: revenueData.map((data) => data.revenue),
          //   backgroundColor: "#064FF0",
          //   borderColor: "#064FF0",
          // },
          {
            label: "Don",
            data: don?.map((data) => data.cost),
            backgroundColor: "#2b2b81",
            borderColor: "#2b2b81",
          },
        ],
      }}
      options={{
        elements: {
          line: {
            tension: 0.5,
          },
        },
        plugins: {
          title: {
            text: "Stastique sur le nombre de don par moi",
          },
        },
      }}
    />
  );
};

export default LineStatistique;
